import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/projects')({
  staticData: { section: 'Production Planning', breadcrumb: 'Projects' },
  component: () => <Outlet />,
});
